<template>
  <nav>
    <div class="warp-top-navbar flex items-center px-4 md:px-[15vw]">
      <div class="container mx-auto py-2">
        <div class="top-nav flex items-center">
          <LogoSimakad class="flex-shrink-0 ml-3 sm:ml-0" />
          <UnivHead />
        </div>
      </div>
    </div>

    <div
      class="warp-bottom-navbar sticky top-0 z-[999] border-t-4 border-[#02735F] px-4 md:px-[15vw]"
    >
      <div class="container mx-auto">
        <!-- Desktop Navbar -->
        <div class="hidden md:flex items-center h-[50px] justify-between">
          <div class="menus flex items-center">
            <div
              v-for="item in mainMenu"
              :key="item.idmw"
              class="relative group max-w-[15%] text-center"
              :class="{
                ' text-yellow-400 rounded-sm':
                  activeSubMenu === item.idmw,
                'text-white': activeSubMenu !== item.idmw,
              }"
            >
              <button
                v-if="!filteredSubMenu[item.idmw]"
                @click="handleMenuClick(item)"
                class="text-lg font-medium mx-4 hover:text-yellow-400"
              >
                {{ item.nama_menu }}
              </button>
              <span
                v-else
                class="text-lg font-medium mx-4 cursor-default hover:text-yellow-400"
              >
                {{ item.nama_menu }}
              </span>

                <div
                v-if="filteredSubMenu[item.idmw]"
                class="absolute text-left left-0 rounded-md bg-[#014a3d] shadow-lg hidden group-hover:block"
              >
                <template
                  v-for="subItem in filteredSubMenu[item.idmw]"
                  :key="subItem.idmw"
                >
                  <router-link
                    v-if="subItem.hasLink"
                    :to="subItem.link"
                    @click="setActiveSubItem(subItem.idmw, item.idmw)"
                    :class="{ 'bg-[#02735F]': activeSubItem === subItem.idmw }"
                    class="block text-white text-lg font-medium px-6  py-3 hover:bg-[#02735F]"
                  >
                    {{ subItem.nama_menu }}
                  </router-link>
                  <span
                    v-else
                    @click="handleSubItemClick(subItem)"
                    :class="{ 'bg-[#02735F]': activeSubItem === subItem.idmw }"
                     class="inline-block w-full text-white text-lg font-medium px-6 py-3 opacity-60 cursor-pointer hover:bg-[#02735F] whitespace-nowrap"
                  >
                    {{ subItem.nama_menu }}
                  </span>
                </template>
              </div>
            </div>
          </div>

          <div class="right-menus">
            <a
              href="http://103.135.49.0:8000/newstikes/"
              target="_blank"
              class="text-white text-lg font-medium px-4 py-2 border border-white rounded bg-[#014a3d] hover:border-yellow-400 hover:text-yellow-400 transition-colors"
            >
              Login
            </a>
          </div>
        </div>

        <!-- Mobile Navbar -->
        <div class="flex md:hidden items-center h-[50px] justify-between px-4">
          <a
            href="http://103.135.49.0:8000/newstikes/"
            target="_blank"
            class="text-white text-l font-medium px-2 py-1 border border-white rounded bg-[#014a3d] hover:border-yellow-400 hover:text-yellow-400 transition-colors"
          >
            Login
          </a>
          <button @click="showMenu = !showMenu" class="text-white">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-8 w-8"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </button>
        </div>

        <!-- Dropdown Mobile Menu -->
        <transition name="slide-fade">
          <div
            v-if="showMenu"
            class="md:hidden absolute left-0 right-0 bg-[#014a3d] z-50 shadow-lg"
          >
            <div v-for="item in mainMenu" :key="item.idmw" class="relative">
              <button
                @click="toggleSubMenu(item.idmw, item.link)"
                :class="{ 'bg-[#02735F]': activeSubMenu === item.idmw }"
                class="block text-white text-lg font-medium px-6 py-3 hover:bg-[#02735F] w-full text-left"
              >
                {{ item.nama_menu }}
              </button>

              <transition name="slide-fade">
                <div
                  v-if="
                    activeSubMenu === item.idmw && filteredSubMenu[item.idmw]
                  "
                  class="bg-[#014a3d] border-b border-b-[#02735F] w-[95%] mx-auto my-2"
                >
                  <template
                    v-for="subItem in filteredSubMenu[item.idmw]"
                    :key="subItem.idmw"
                  >
                    <router-link
                      v-if="subItem.hasLink"
                      :to="subItem.link"
                      @click="setActiveSubItem(subItem.idmw)"
                      :class="{
                        'bg-[#02735F]': activeSubItem === subItem.idmw,
                      }"
                      class="block text-white text-lg px-6 py-3 hover:bg-[#02735F] rounded-[15px]"
                    >
                      {{ subItem.nama_menu }}
                    </router-link>
                    <span
                      v-else
                      @click="handleSubItemClick(subItem)"
                      class="block text-white text-lg px-6 py-3 opacity-60 cursor-default"
                    >
                      {{ subItem.nama_menu }}
                    </span>
                  </template>
                </div>
              </transition>
            </div>
          </div>
        </transition>
      </div>
    </div>

    <!-- Modal Notification -->
    <transition name="fade">
      <div
        v-if="showModal"
        class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      >
        <div class="bg-white p-6 rounded shadow-lg text-center">
          <p class="text-lg font-medium">{{ modalMessage }}</p>
          <button
            @click="closeModal"
            class="mt-4 px-4 py-2 bg-[#02735F] text-white rounded hover:bg-[#014a3d]"
          >
            OK
          </button>
        </div>
      </div>
    </transition>
  </nav>
  <router-view />
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from "vue";
import { useRouter } from "vue-router";
import { useMenuSimakadStore } from "@/store/menuSimakadStore";
import LogoSimakad from "../LogoSimakad.vue";
import UnivHead from "../navbar/UnivHead.vue";

const showMenu = ref(false);
const activeSubMenu = ref(null);
const activeSubItem = ref(null);
const showModal = ref(false);
const modalMessage = ref("");
const router = useRouter();

const menuStore = useMenuSimakadStore();
onMounted(() => {
  menuStore.fetchNavItems();
});

const staticNavItems = computed(() => menuStore.staticNavItems);

const mainMenu = computed(() =>
  staticNavItems.value.filter(
    (item) => item.is_child === "0" && item.is_aktif === "t"
  )
);

const filteredSubMenu = computed(() => {
  const map = {};
  staticNavItems.value.forEach((item) => {
    if (item.is_child !== "0" && item.is_aktif === "t") {
      if (!map[item.is_child]) {
        map[item.is_child] = [];
      }
      map[item.is_child].push({
        ...item,
        hasLink: !!item.link
      });
    }
  });
  return map;
});

onMounted(() => {
  console.log("Filtered SubMenu:", filteredSubMenu.value);
});

const toggleSubMenu = (id, link) => {
  if (!filteredSubMenu.value[id]) {
    activeSubMenu.value = null;
    if (link) {
      showMenu.value = false;
      router.push(link);
    }
  } else {
    activeSubMenu.value = activeSubMenu.value === id ? null : id;
  }
};

const setActiveSubItem = (id, parentId) => {
  activeSubItem.value = id;
  activeSubMenu.value = parentId;
  showMenu.value = false;
};

const handleMenuClick = (item) => {
  if (!item.link) {
    modalMessage.value = `Menu '${item.nama_menu}' tidak memiliki link.`;
    showModal.value = true;
  } else {
    activeSubMenu.value = item.idmw;
    router.push(item.link);
  }
};

const handleSubItemClick = (subItem) => {
  if (!subItem.link) {
    modalMessage.value = `Submenu '${subItem.nama_menu}' tidak memiliki link.`;
    showModal.value = true;
    showMenu.value = false;
  } else {
    router.push(subItem.link);
    showMenu.value = false;
  }
};

const closeModal = () => {
  showModal.value = false;
};

onMounted(() => {
  const handleClickOutside = (event) => {
    const menuEl = document.querySelector(".warp-bottom-navbar");
    if (menuEl && !menuEl.contains(event.target)) {
      showMenu.value = false;
    }
  };
  document.addEventListener("click", handleClickOutside);
  onUnmounted(() => {
    document.removeEventListener("click", handleClickOutside);
  });
});
</script>

<style scoped lang="scss">
.warp-top-navbar {
  width: 100%;
  flex-shrink: 0;
  background: linear-gradient(91deg, #014a3d 20.41%, #02735f 99.51%);
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  .univ-name {
    font-family: "Playfair Display", serif;
  }
}

.warp-bottom-navbar {
  width: 100%;
  min-height: 50px;
  background-color: #014a3d;
  position: relative;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}
.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
